import { render, staticRenderFns } from "./general.view.vue?vue&type=template&id=4a377691&"
import script from "./general.view.vue?vue&type=script&lang=ts&"
export * from "./general.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports